import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CloudinaryTransforms } from './cloudinary-transforms.class';
import { CloudinaryImageService } from './cloudinary-image.service';


export class CloudinaryImageComponent implements OnChanges {
    imageUrl: string = '';
    transforms: CloudinaryTransforms = new CloudinaryTransforms();

     publicId: string;
     cloudName: string;
     type: string;
     title: string;
     alt: string;

    constructor(private _imageService: CloudinaryImageService) { }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.publicId && this.cloudName) {
            const resourceType: string = 'image';
            const type: string = this.type || 'upload';
            this.imageUrl = this._imageService.getImageUrl(this.publicId, this.cloudName, resourceType, type, this.transforms);
        } else {
            this.imageUrl = '';
        }
    }

    
    set width(value: number) {
        this.transforms.width = value;
    }

    
    set height(value: number) {
        this.transforms.height = value;
    }

    
    set crop(value: string) {
        this.transforms.crop = value;
    }

    
    set aspect_ratio(value: string) {
        this.transforms.aspect_ratio = value;
    }

    
    set gravity(value: string) {
        this.transforms.gravity = value;
    }

    
    set zoom(value: number) {
        this.transforms.zoom = value;
    }

    
    set x(value: number) {
        this.transforms.x = value;
    }

    
    set y(value: number) {
        this.transforms.y = value;
    }

    
    set format(value: string) {
        this.transforms.format = value;
    }

    
    set quality(value: string) {
        this.transforms.quality = value;
    }

    
    set radius(value: string) {
        this.transforms.radius = value;
    }

    
    set angle(value: string) {
        this.transforms.angle = value;
    }

    
    set effect(value: string) {
        this.transforms.effect = value;
    }

    
    set opacity(value: number) {
        this.transforms.opacity = value;
    }

    
    set border(value: string) {
        this.transforms.border = value;
    }

    
    set background(value: string) {
        this.transforms.background = value;
    }

    
    set overlay(value: string) {
        this.transforms.overlay = value;
    }

    
    set underlay(value: string) {
        this.transforms.underlay = value;
    }

    
    set default_image(value: string) {
        this.transforms.default_image = value;
    }

    
    set delay(value: number) {
        this.transforms.delay = value;
    }

    
    set color(value: string) {
        this.transforms.color = value;
    }

    
    set dpr(value: string) {
        this.transforms.dpr = value;
    }

    
    set page(value: number) {
        this.transforms.page = value;
    }

    
    set density(value: number) {
        this.transforms.density = value;
    }

    
    set flags(value: string) {
        this.transforms.flags = value;
    }

    
    set transformation(value: string) {
        this.transforms.transformation = value;
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'cl-image',
    template: `
    <img [src]="imageUrl" [title]="title || ''" [alt]="alt || ''">
  `
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: CloudinaryImageService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'publicId': [{ type: Input, args: ['public-id', ] },],
'cloudName': [{ type: Input, args: ['cloud-name', ] },],
'type': [{ type: Input },],
'title': [{ type: Input },],
'alt': [{ type: Input },],
'width': [{ type: Input },],
'height': [{ type: Input },],
'crop': [{ type: Input },],
'aspect_ratio': [{ type: Input, args: ['aspect-ratio', ] },],
'gravity': [{ type: Input },],
'zoom': [{ type: Input },],
'x': [{ type: Input },],
'y': [{ type: Input },],
'format': [{ type: Input },],
'quality': [{ type: Input },],
'radius': [{ type: Input },],
'angle': [{ type: Input },],
'effect': [{ type: Input },],
'opacity': [{ type: Input },],
'border': [{ type: Input },],
'background': [{ type: Input },],
'overlay': [{ type: Input },],
'underlay': [{ type: Input },],
'default_image': [{ type: Input, args: ['default-image', ] },],
'delay': [{ type: Input },],
'color': [{ type: Input },],
'dpr': [{ type: Input },],
'page': [{ type: Input },],
'density': [{ type: Input },],
'flags': [{ type: Input },],
'transformation': [{ type: Input },],
};
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
